import { render, staticRenderFns } from "./LeftnaviDotSvg.vue?vue&type=template&id=687a616c&"
import script from "./LeftnaviDotSvg.vue?vue&type=script&lang=js&"
export * from "./LeftnaviDotSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports